import { render, staticRenderFns } from "./read-table.vue?vue&type=template&id=112efda7&scoped=true"
import script from "./read-table.vue?vue&type=script&lang=ts"
export * from "./read-table.vue?vue&type=script&lang=ts"
import style0 from "./read-table.vue?vue&type=style&index=0&id=112efda7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112efda7",
  null
  
)

export default component.exports